import { InputText } from 'primereact/inputtext';
import React from 'react';
import T from 'services/lang/LanguageService';

interface SetpointTableTitlesEditorProps {
    currentConfig: any;
    handleTableTitlesChange: (id: string, value: string) => void;
}


const SetpointTableTitlesEditor = ({ currentConfig, handleTableTitlesChange }: SetpointTableTitlesEditorProps) => {
    return (
        <>
            <div className='col-3 gap-2 flex flex-column justify-content-center align-items-center'>
                <label htmlFor='datasetTitle'>{T("word.dataset-title")}</label>
                <InputText
                    id='datasetTitle'
                    type='text'
                    value={currentConfig.tableTitles?.datasetTitle}
                    onChange={(e) => handleTableTitlesChange(e.target.id, e.target.value)}
                />
            </div>
            <div className='col-3 gap-2 flex flex-column justify-content-center align-items-center'>
                <label htmlFor='datasetValueTitle'>{T("word.dataset-value-title")}</label>
                <InputText
                    id='datasetValueTitle'
                    type='text'
                    value={currentConfig.tableTitles?.datasetValueTitle}
                    onChange={(e) => handleTableTitlesChange(e.target.id, e.target.value)}
                />
            </div>
            <div className='col-3 gap-2 flex flex-column justify-content-center align-items-center'>
                <label htmlFor='setpointValueTitle'>{T("word.setpoint-value-title")}</label>
                <InputText
                    id='setpointValueTitle'
                    type='text'
                    value={currentConfig.tableTitles?.setpointValueTitle}
                    onChange={(e) => handleTableTitlesChange(e.target.id, e.target.value)}
                />
            </div>
            <div className='col-3 gap-2 flex flex-column justify-content-center align-items-center'>
                <label htmlFor='tagTitle'>{T("word.tag-title")}</label>
                <InputText
                    id='tagTitle'
                    type='text'
                    value={currentConfig.tableTitles?.tagTitle}
                    onChange={(e) => handleTableTitlesChange(e.target.id, e.target.value)}
                />
            </div>
        </>
    );
};

export default SetpointTableTitlesEditor;
